




















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { productBrandList } from '@/api/product';

@Component({
  name: 'ams-brand-selector'
})
export default class AMSBrandSelector extends Vue {
  menuVisible: boolean = false;
  items: Array<any> = [];
  selectItem: any = null;
  /**是否正在获取分类 */
  isLoading: boolean = false;
  /**文本框宽度 */
  @Prop({ default: 'auto' }) width!: string;
  /**文本框高度 */
  @Prop({ default: 'auto' }) height!: string;
  /**表单验证规则 */
  @Prop({
    default: () => {
      return [];
    }
  })
  rules!: Array<any>;
  @Prop({ default: '' }) value!: string;
  @Prop({ default: '' }) label!: string;

  allItem() {
    return { id: '-1', name: '全部', isSelected: false, parentId: '' };
  }

  get showClose() {
    return this.selectItem && this.selectItem.id != this.allItem().id;
  }

  get arrowIcon() {
    return this.menuVisible ? 'arrow_drop_up' : 'arrow_drop_down';
  }
  onEnter() {
    const text = this.$refs.text as any;
    if (text) {
      text.blur();
    }
  }

  /**文本框样式 */
  get textStyle() {
    return `width:${this.width};height:${this.height}`;
  }

  /**显示选中的item */
  get name() {
    return this.selectItem ? this.selectItem.name : this.allItem().name;
  }

  /**显示箭头 */
  get appendIcon() {
    if (this.selectItem && this.selectItem.id != this.allItem().id) {
      return 'clear';
    } else {
      return this.menuVisible ? 'arrow_drop_up' : 'arrow_drop_down';
    }
  }

  onAppendClick(event: any) {
    if (this.selectItem && this.selectItem.id != this.allItem().id) {
      this.selectItem = {};
      this.$emit('input', {});
    } else {
      this.menuVisible = !this.menuVisible;
    }
  }

  /**获取数据 */
  getBrand() {
    this.isLoading = true;
    productBrandList()
      .then((response: any) => {
        this.isLoading = false;
        if (response != null && response.items.length > 0) {
          this.items = response.items;
          this.items.unshift(this.allItem());
          if (this.selectItem) {
            this.items.map((v: any, i: any) => {
              if (v.id == this.selectItem.id) {
                v.isSelected = true;
              }
            });
          } else {
            this.selectItem = this.items[0];
          }
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
      });
  }

  @Watch('menuVisible', { immediate: true, deep: true })
  onMenuVisibleChange(newValue: boolean, oldValue: boolean) {
    if (newValue == true) {
      this.items = [];
      this.getBrand();
    } else {
      const text = this.$refs.text as any;
      if (text) {
        text.focus();
      }
    }
  }

  onItemClick(item: any, index: number) {
    this.selectItem = item;
    item.id = item.id == this.allItem().id ? item.parentId : item.id;
    this.$emit('input', item);
    this.menuVisible = false;
  }

  @Watch('value', { immediate: true, deep: true })
  onValueChange(newValue: any, oldValue: any) {
    if (newValue == undefined || newValue == null || newValue === '' || Object.keys(newValue).length <= 0) {
      this.items = [];
      this.selectItem = null;
      this.getBrand();
    } else {
      this.selectItem = newValue;
    }
  }
}
